module.exports = __webpack_public_path__ + "static/media/progress-books-completed.f3a677f6.svg";